import { Capacitor } from '@capacitor/core';

import { getRuntimeConfigFetchUrl } from './runtime-config-url';

const BROWSER_ERROR_PATH = '/api/browser-error';
const RUNTIME_CONFIG_PATH = '/api/runtime-config';

/**
 * The browser-error relay is hosted by the app deployment, not NestJS.
 *
 * Web traffic can use a same-origin path. A bundled Capacitor app runs at
 * https://localhost (or capacitor://localhost), so that same relative path
 * points back into the WebView and never reaches Vercel. The runtime-config
 * resolver already knows the correct app deployment for native builds; reuse
 * that origin so both endpoints stay aligned in production and previews.
 */
export function getBrowserErrorEndpoint(): string {
  if (!Capacitor.isNativePlatform()) return BROWSER_ERROR_PATH;

  const runtimeConfigUrl = getRuntimeConfigFetchUrl();
  if (!runtimeConfigUrl.endsWith(RUNTIME_CONFIG_PATH)) {
    return BROWSER_ERROR_PATH;
  }

  return `${runtimeConfigUrl.slice(0, -RUNTIME_CONFIG_PATH.length)}${BROWSER_ERROR_PATH}`;
}
